<template>
  <div class="similar-cards" v-if="cards.length > 0">
    <align class="header" flex>
      <h4 class="secondary-font">Similar</h4>

      <icon-link
        v-if="!isPublic && ids.length"
        @click="$router.push(`/compare?ids=${ids}`)"
      >
        Compare all
      </icon-link>
    </align>

    <div class="list">
      <card-list-item
        v-for="card in cards"
        :key="card.id"
        :card="card"
        :fields="['currentValue']"
        :to="getCardTo(card.id)"
        as="router-link"
      />
    </div>
  </div>
</template>

<script>
import CardListItem from './CardListItem';
import IconLink from './IconLink';
import Align from './Align';

import { toImageUrl } from '../utils/format.util';

export default {
  components: {
    CardListItem,
    IconLink,
    Align,
  },

  props: {
    similarCards: Array,
    id: String,
    isPublic: Boolean,
    page: Boolean,
  },

  computed: {
    cards() {
      if (!this.similarCards || this.similarCards.length === 0) {
        return [];
      }

      return this.similarCards.map((similarCard) => ({
        ...similarCard,
        image: toImageUrl(`cards/thumb_${similarCard.id}`),
      }));
    },

    ids() {
      if (!this.id) {
        return [];
      }

      return [this.id, ...this.cards.map(({ id }) => id)].join(',');
    },
  },

  methods: {
    getCardTo(id) {
      const query = { ...this.$route.query };
      delete query.profile;
      delete query.saleId;

      if (this.isPublic) {
        return `/ladder/card/${id}`;
      } else if (this.page) {
        return {
          ...this.$route,
          params: { id },
          query,
        };
      } else {
        return {
          ...this.$route,
          query: {
            ...query,
            cardId: id,
          },
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.similar-cards {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.header {
  margin-bottom: $gp;

  h4 {
    margin-bottom: 0;
  }
}

.list {
  margin: 0 (-$gp);
}
</style>
